import { create } from 'zustand';
import { UploadFileType } from '../api/generated';

interface DownloadState {
  /** Progress percentage (0–100) per file type, undefined = not downloading */
  progress: Partial<Record<UploadFileType, number>>;
  setProgress: (fileType: UploadFileType, value: number | undefined) => void;
}

export const useDownloadStore = create<DownloadState>((set) => ({
  progress: {},
  setProgress: (fileType, value) =>
    set((state) => {
      if (value === undefined) {
        const { [fileType]: _, ...rest } = state.progress;
        return { progress: rest };
      }
      return { progress: { ...state.progress, [fileType]: value } };
    }),
}));
